import { vdaScore, vdaScoreCurated, vdaScoreLiterature, vdaScoreBiobank } from '../../AboutHelpers.tsx';
import { FormulaAccordion } from './components/FormulaAccordion';
import { ScoreComponentsVisual, ScoreComponent } from './components/ScoreComponentsVisual';
import { WeightStepGrid } from './components/WeightStepGrid';

const VDA_COMPONENTS: ScoreComponent[] = [
  {
    key: 'curated',
    label: 'Curated',
    maxWeight: 0.7,
    hex: '#0a104f',
    textHex: '#0a104f',
    sources: ['CLINGEN', 'CLINPGX', 'CLINVAR', 'GWASCAT', 'PHEWASCAT', 'UNIPROT'],
    weightSteps: [
      { condition: '|S_C| > 2 sources', weight: 0.7 },
      { condition: '|S_C| = 2 sources', weight: 0.6 },
      { condition: '|S_C| = 1 source', weight: 0.4 },
      { condition: '|S_C| = 0 sources', weight: 0.0 },
    ],
  },
  {
    key: 'biobank',
    label: 'Biobank',
    maxWeight: 0.2,
    hex: '#0EA5E9',
    textHex: '#0369A1',
    sources: ['FINNGEN', 'UKBIOBANK'],
    weightSteps: [
      { condition: '|S_B| > 0 sources', weight: 0.2 },
      { condition: '|S_B| = 0 sources', weight: 0.0 },
    ],
  },
  {
    key: 'literature',
    label: 'Literature',
    maxWeight: 0.4,
    hex: '#B45309',
    textHex: '#B45309',
    sources: ['TEXTMINING HUMAN'],
    weightSteps: [
      { condition: 'N_Pubs > 99', weight: 0.4 },
      { condition: '9 < N_Pubs ≤ 99', weight: 0.3 },
      { condition: '1 < N_Pubs ≤ 9', weight: 0.2 },
      { condition: 'N_Pubs = 1', weight: 0.1 },
      { condition: 'N_Pubs = 0', weight: 0.0 },
    ],
  },
];

function AboutMetricsVdaScore(): React.ReactElement {
  return (
    <div id="vdaScore">
      <h3>VDA Score</h3>
      <p>
        The DISGENET Score (S<sub style={{ fontSize: 'smaller', marginLeft: 2 }}>VDA</sub>) for VDAs is
        computed according to the weighted sum of three evidence components. Hover over any value to see how
        it scales with the number of supporting sources.
      </p>
      <ScoreComponentsVisual
        components={VDA_COMPONENTS}
        note="Values (≤ x.xx) are the maximum each component can contribute. Hover to see the full scale."
      />
      <FormulaAccordion label="View formula details">
        <WeightStepGrid components={VDA_COMPONENTS} />
        <span>{vdaScore()}</span>
        <br />
        <span>{vdaScoreCurated()}</span>
        <br />
        <span>{vdaScoreBiobank()}</span>
        <br />
        <span>{vdaScoreLiterature()}</span>
      </FormulaAccordion>
    </div>
  );
}

export default AboutMetricsVdaScore;
